import React, { useEffect, useState } from "react";
import "./CardCoursEtudiant.css";

import Card from "react-bootstrap/Card";

import { BiTimeFive } from "react-icons/bi";
import { updateStatusCours, forNotification } from "../../../Firebase";
import { Col } from "react-bootstrap";
import { Timestamp } from "firebase/firestore";

import { SamaDate } from "../../../Services";
import { Link } from "react-router-dom";
import { INFO_COURS } from "../../../Routes/NAVIGATION_PATH";

export default function CardCoursEtudiant({ item }) {
  const currentUserId = sessionStorage.getItem("user_id");
  const [allStatus, setAllStatus] = useState([]);
  const [myStatus, setMyStatus] = useState([]);

  useEffect(() => {
    setAllStatus(item?.etudiants);
    setMyStatus(
      item?.etudiants?.filter((user) => user?.etudiant_id === currentUserId)
    );
  }, [item?.etudiants]);

  const data = {
    etudiant_id: currentUserId,
    isFinish: false,
    isValid: false,
    demarrage: Timestamp.fromDate(new Date()),
  };

  const mydatas = () => {
    const update = allStatus;
    if (myStatus.length === 0) {
      update.push(data);
    } else {
      myStatus[0].isFinish = true;
      myStatus[0].terminer = Timestamp.fromDate(new Date());
      update.push(...myStatus);
    }
    return update;
  };

  return (
    <Col lg={4} md={6}>
      <Card
        className="my-2"
        style={{
          borderRadius: "10px",
          minHeight: "",
        }}
      >
        <iframe
          height={200}
          src={item?.lien_cours}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        <Card.Text className=" pt-2 px-4">
          <h5 className="message-notif">
            <span>Titre :</span> {item?.titre_cours}
          </h5>
          <h6 className="message-notif">{item?.description}</h6>
          <div className="d-flex bd-highlight">
            <div className="  ">
              <BiTimeFive />
            </div>
            <div className="message-notif mx-1">
              {<SamaDate mydate={item?.created_on}/>}
            </div>
          </div>
        </Card.Text>
        <hr />
        <div className="head-cart pt-2 px-4">
          <div className="d-flex bd-highlight im-prof mb-3">
            <div className="p2 bd-highlight im  ">
              <Link to={`${INFO_COURS}/${item?.id}`}>
                <button className="btn btn-md btn-info">Details</button>
              </Link>
            </div>

            <div className="ms-auto  ai bd-highlight">
              {myStatus?.length === 0 ? (
                <button
                  className="btn btn-md btn-success"
                  onClick={() =>
                    updateStatusCours(
                      item?.id,
                      mydatas(),
                      "Cours démarrer avec succès !"
                    ).then(
                      forNotification(
                        `a demarré un dont le titre ${item?.titre_cours} merci de suivre son evolution`,
                        item?.created_by
                      )
                    )
                  }
                >
                  Démarrer
                </button>
              ) : myStatus[0].isFinish === true ? null : (
                <button
                  className="btn btn-md btn-primary"
                  onClick={() =>
                    updateStatusCours(
                      item?.id,
                      mydatas(),
                      "Cours terminer avec succès !"
                    ).then(
                      forNotification(
                        `a terminé un cours dont le titre ${item?.titre_cours} merci de valider`,
                        item?.created_by
                      )
                    )
                  }
                >
                  Terminer
                </button>
              )}
            </div>
          </div>
        </div>
      </Card>
    </Col>
  );
}
